import {formatDate} from '@angular/common';

export class Utils {
	static isEmpty(object: any): boolean {
		if (object === undefined || object === null || object === '') {
			return true;
		}
		return false;
	}

	static formatDateUsa(date: string): string {
		if (!date) return;
		const format = 'yyyy-MM-dd';
		const myDate = date;
		const locale = 'en-US';
		return formatDate(myDate, format, locale);
	}

	static formatDateBr(date: Date): string {
		const format = 'dd-MM-y';
		const myDate = date;
		const locale = 'en-US';
		return formatDate(myDate, format, locale);
	}

	static formatDateBrString(date: string): string {
		const format = 'dd/MM/y';
		const myDate = date;
		const locale = 'en-US';
		return formatDate(myDate, format, locale);
	}

	static getYear(): string {
		const format = 'yyyy';
		const myDate = new Date;
		const locale = 'en-US';
		return formatDate(myDate, format, locale);
	}

	static getUniqueArray(array) {
		const uniqueArray = [];
		for ( let i = 0; i < array.length; i++) {
			if (uniqueArray.indexOf(array[i]) === -1) {
				uniqueArray.push(array[i]);
			}
		}
		return uniqueArray;
	}
}
